import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class ScrollService {
  constructor(private router: Router) {}
  scrollToElementById(id: string, scrollToTop: boolean = true) {
    const element = this.__getElementById(id);
    this.scrollToElement(element, scrollToTop);
  }

  private __getElementById(id: string): HTMLElement {
    // const element = <HTMLElement>document.querySelector(`#${id}`);
    const element = document.getElementById(id) as HTMLElement;
    return element;
  }

  scrollToElement(element: HTMLElement, scrollToTop: boolean = false) {
    if(element){
      element.scrollIntoView({ behavior: "smooth", block: "start" });
      // Scroll up 10px from start position
      if(scrollToTop == true){
        setTimeout(() => {
          window.scrollBy({ top: -30, behavior: "smooth" });
        }, 0);
      }
    }
  }
}
